/*
 * Copyright (c) 2023 Helvia Technologies PC <contact@helvia.io>
 */

/**
 * Formats a given unit amount by dividing it by 100 and fixing it to 2 decimal places.
 *
 * @param {number} unitAmount - The unit amount to be formatted.
 * @returns {string} The formatted unit amount as a string with 2 decimal places.
 *
 * @example
 * // Example 1:
 * const result1 = numberToFixed(15000);
 * console.log(result1); // Output: "150.00"
 *
 * @example
 * // Example 2:
 * const result2 = numberToFixed(12345.6789);
 * console.log(result2); // Output: "123.46"
 */
export const numberToFixed = (unitAmount: number): string => {
  return (unitAmount / 100).toFixed(2) 
};